import {currencyFormat} from "../utils";

export const CenteredMetric = ({nodes, centerX, centerY, valueFormat}: any) => {

    // @ts-ignore
    const total = nodes.reduce((total, datum) => {
        if (datum.depth === 1) return total + datum.value;
        return total;
    }, 0)

    return (
        <text x={centerX}
              y={centerY}
              textAnchor="middle"
              dominantBaseline="central"
              style={{
                  fontSize: '36px',
                  fontWeight: 600,
              }}>{valueFormat === 'currency' ? currencyFormat(total) : total}</text>
    )
}
